import { Component, OnInit } from '@angular/core';
import { RouterModule, Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { TdDialogService } from '@covalent/core';
import { Route } from '@angular/router/src/config';
import { AuthenticationService } from '../../../../../shared/services/authentication.service';
import { ReceivingService } from '../../../../receiving/receiving.service';
import { ReceivingItem } from '../../../../receiving/receiving-item';
import { ITdDataTableColumn, TdDataTableComponent } from '@covalent/core/data-table/data-table.component';
import { TranslatePipe } from '../../../../../shared/pipes/translate.pipe';
import { LocationService } from 'services/location.service';
import { ViewChild } from '@angular/core';
import { InventoryService } from '../../../../inventory/inventory.service';
import { Piece } from '../../../../inventory/piece';
import { SalesService } from '../../../../sales/sales.service';
import { InvoiceService } from '../../../../../shared/services/invoice.service';

@Component({
  selector: 'app-return-pieces',
  templateUrl: './return-pieces.component.html',
  styleUrls: [],
  providers: [SalesService, InvoiceService]
})
export class ReturnPiecesComponent implements OnInit {
  @ViewChild('dataTable') dataTable: TdDataTableComponent;

  id: string;
  order_number: string = '';
  order_items: Piece[] = [];

  piece_no: string;
  piece_location: string;
  piece_length: number;
  piece_weight: number;

  locations: any[] = [];

  external_order: boolean = true;

  translatePipe: TranslatePipe = new TranslatePipe();

  transaction_status: string[] = [];
  confirmation_length: number = 0;

  _branch_id: number;

  columns: ITdDataTableColumn[] = [
    { name: 'check', label: '' },
    { name: 'piece_number', label: this.translatePipe.transform('piece_no', this._authService.getLanguage()) },
    { name: 'location', label: this.translatePipe.transform('location', this._authService.getLanguage()) },
    { name: 'quantity', label: this.translatePipe.transform('length', this._authService.getLanguage()) },
    { name: 'weight', label: this.translatePipe.transform('weight_kg', this._authService.getLanguage()) },
  ];

  constructor(private router: Router,
    private _dialogService: TdDialogService,
    private location: Location,
    private route: ActivatedRoute,
    private _salesService: SalesService,
    private _invoiceService: InvoiceService,
    private _locationService: LocationService,
    private _inventoryService: InventoryService,
    public _authService: AuthenticationService
  ) { }

  ngOnInit() {
    this.route.params.subscribe(
      params => {
        this.id = params['return_id'];
        this._salesService.getRefundItems(this.id).subscribe(
          response => {
            this.order_items = response;
            //Calculate the proportional weights and clean up the locations
            this.order_items.forEach(
              item => {
                delete item.location;
                item.weight = item.weight * (item.quantity / item.full_length);
              }
            );
          }
        );
        /*this._receivingService.getReceivingItems(this.id + '').subscribe(
          response => {
            this.order_items = response;
          }
        );*/
      }
    );

    this.route.queryParams.subscribe(
      params => {
        this.order_number = params['order_number'];
        this._branch_id = params['branch_id'];

        // Get locations for the specific branch
        this.getLocations();
      }
    );
  }

  scanned() {
    // If location is not in the list
    if (this.locations.find((l) => { return l.name == this.piece_location }) == null) {
      this._dialogService.openAlert({
        title: 'Invalid Location',
        message: 'The location that you scanned is not registered in your home branch'
      });
      return;
    }

    let this_item: Piece = this.order_items.find((item) => { return item.piece_number == this.piece_no });

    if (this_item == null) {
      this._dialogService.openAlert({
        title: 'Invalid Item',
        message: 'The item that you scanned is not part of this receiving order'
      });
      return;
    } else {
      this_item['checked'] = true;
      this_item['location'] = this.piece_location;
      // Commented out the piece_length and piece_weight cause they are not overwritable anymore.
      this_item['scanned_length'] = this_item['length'];//this.piece_length;
      this_item['scanned_weight'] = this_item['weight'];//this.piece_weight;
    }

    // Force change detection
    this.dataTable.refresh();

    //Then clear input fields
    this.piece_no = undefined;
    // Keep location though
    //this.piece_location = undefined;
  }

  confirmOrder() {
    let scanned = this.order_items.filter((i) => { return i['checked'] == true });
    let not_scanned = this.order_items.filter((i) => { return i['checked'] != true });

    if (not_scanned.length > 0) {
      this._dialogService.openConfirm({
        title: 'Warning!',
        message: 'Not all items in the order have been scanned. Do you want to continue?',
        acceptButton: 'Yes',
        cancelButton: 'No'
      }).afterClosed().subscribe(
        result => {
          if (result) {
            this.doConfirmOrder(scanned);
          }
        }
      );
    } else {
      this.doConfirmOrder(scanned);
    }
  }

  doConfirmOrder(final_items: Piece[]) {
    // We expect final_items.length + 2 confirmations
    this.confirmation_length = final_items.length + 2;

    // Set the return order to RECEIVED
    this._salesService.getOneRefund(this.id).subscribe(
      response => {
        response.status = 'RECEIVED';
        // Update the REFUND to RECEIVED
        this._salesService.updateRefund(Number.parseInt(this.id), response).subscribe(
          response => {
            this.reportStatus('Return order marked as RECEIVED', true);
          },
          error => {
            this.reportStatus('Could not mark Return order as RECEIVED', true);
          }
        )

        // Add the credit to the invoices list
        this._invoiceService.createInvoice(
          response.customer_id,
          response.branch_id,
          new Date().toISOString().substr(0,10),
          'Return',
          (this.totalProduct(this.order_items, 'quantity', 'unit_price') + (response.shipping_charges*1) - (response.discount*1))* (1 + (response.tax/100)),
          response.invoice_number || response.order_number ||''
        ).subscribe(
          response => {
            this.reportStatus('Return added to the invoices list', true);
          },
          error => {
            this.reportStatus('Could not add return to the invoices list. Please add it manually', true);
          }
        );
      }
    );

    // Add the pieces to the inventory
    final_items.forEach(
      (item) => {
        let piece: Piece = new Piece();

        piece.piece_number = item.piece_number;
        // This to figure out the color_id 
        piece.color_name = item.color_name;
        piece.collection_name = item.collection_name;
        piece.design_name = item.design_name;
        // Piece specs
        piece.lot_number = item.lot_number;
        piece.length = item.quantity;
        piece.weight = item.weight;
        // Location
        // id is most likely null, need branch
        piece.location_id = Number.parseInt(item.location_id + '');
        piece.location_name = item.location;

        piece.branch_id = this._branch_id;

        // Add it to the inventory!
        this._inventoryService.addPiece(piece, false).subscribe(
          response => {
            if (response['status'] == 'SUCCESS') {
              this.reportStatus('Piece ' + response['piece_number'] + ' added back to the inventory');
            } else {
              this.reportStatus('Piece ' + response['piece_number'] + ' could not be added back to the inventory');
            }
          },
          error => {
            this.reportStatus('Piece ' + error['piece_number'] + ' could not be added back to the inventory');
          }
        );
      }
    )
  }

  totalProduct(data: any[], field1: string, field2: string) {
    return data.reduce(function (a, b) { return Number.parseFloat(a) + (Number.parseFloat(b[field1]) * Number.parseFloat(b[field2])) }, 0);
  }

  reportStatus(status: string, prepend?: boolean) {
    if (prepend) {
      this.transaction_status.unshift(status);
    } else {
      this.transaction_status.push(status);
    }

    if (this.transaction_status.length == this.confirmation_length) {
      this._dialogService.openAlert(
        {
          title: 'Result',
          message: this.transaction_status.join(', ')
        }
      ).afterClosed().subscribe(
        result => {
          this.router.navigate(['/pda', 'receiving', 'return']);
        });
    }
  }

  goBack(): void {
    this.location.back();
  }

  suggestSpecs() {
    let entry: Piece;

    entry = this.order_items.find((item) => { return item.piece_number == this.piece_no });

    if (entry != null) {
      this.piece_length = entry.length;
      this.piece_weight = entry.weight;
    } else {
      this.piece_length = undefined;
      this.piece_weight = undefined;
    }
  }

  getLocations() {
    this._locationService.getLocations(/*this._authService.getHomeBranch()*/this._branch_id + '').subscribe(
      response => {
        this.locations = response;
      }
    );
  }
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/pda/receiving/returns/return-pieces/return-pieces.component.ts